import React from 'react'
import SvgWrapper from '../SvgWrapper'
import { ICON_SIZE, ICON_VIEWBOX } from './constants'
import type { IconProps } from './types'

const ArrowSubDownRight: React.FC<IconProps> = ({
  color = 'currentColor',
  fillOpacity,
  size = ICON_SIZE.medium,
  viewBox = ICON_VIEWBOX.medium,
}) => (
  <SvgWrapper viewBox={viewBox} size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 2a1 1 0 0 1 1 1v9.8c0 .577 0 .949.024 1.232.022.271.06.372.085.422a1 1 0 0 0 .437.437c.049.025.15.063.42.085.284.023.655.024 1.23.024h5.39l-3.293-3.293a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L15.586 17h-5.428c-.526 0-.98 0-1.354-.03-.395-.033-.788-.104-1.166-.297a3 3 0 0 1-1.311-1.311c-.193-.379-.264-.772-.296-1.167C6 13.82 6 13.365 6 12.839V3a1 1 0 0 1 1-1Z"
      fill={color}
      fillOpacity={fillOpacity}
    />
  </SvgWrapper>
)

export default ArrowSubDownRight
